import calcWidth from "./helpers";
import { v4 as uuidv4 } from "uuid";
import {
  TopolCustomBlockData,
  TopolCustomBlockMixContentWithKey,
  TopolCustomBlockMixContent,
} from "@/schemas/contentBlock/contentBlockScheme";
import button from "./button";
import image from "./image";
import text from "./text";
import video from "./video";
import { mergeDeep } from "@/utils/mergeDeep";
import { TopolRawBlock } from "@/schemas/template/blocks/rawBlockSchema";

export default {
  getData(
    state: any,
    props: { sectionIndex: number; columnIndex: number },
    customBlockData: TopolCustomBlockData
  ) {
    if (!customBlockData.type) {
      return {
        uid: uuidv4(),
        tagName: "mj-raw",
        content: customBlockData.content,
        custom: true,
        key: customBlockData.key,
        attributes: {
          containerWidth: calcWidth(
            state.mjml.children[0].attributes["containerWidth"],
            state.mjml.children[0].children[props.sectionIndex].children[
              props.columnIndex
            ].attributes["width"]
          ),
        },
      } as TopolRawBlock;
    }

    if (
      customBlockData.type === "mix" &&
      Array.isArray(customBlockData.blocks)
    ) {
      const blocks: ReturnType<typeof this.getTypeBlockData>[] = [];
      customBlockData.blocks.forEach((block: TopolCustomBlockMixContent) => {
        const blockWithKey: TopolCustomBlockMixContentWithKey = mergeDeep(
          block,
          { key: customBlockData.key }
        );
        blocks.push(this.getTypeBlockData(state, props, blockWithKey));
      });
      return blocks;
    }

    return this.getTypeBlockData(state, props, customBlockData);
  },

  getTypeBlockData(
    state: any,
    props: { sectionIndex: number; columnIndex: number },
    customBlockData: TopolCustomBlockData | TopolCustomBlockMixContentWithKey
  ) {
    switch (customBlockData.type) {
      case "button":
        return button.getData(state, props, customBlockData);
      case "text":
        return text.getData(state, props, customBlockData);
      case "image":
        return image.getData(state, props, customBlockData);
      case "video":
        return video.getData(state, props, customBlockData);
    }
  },
};
